import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7aa262ae&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=7aa262ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa262ae",
  null
  
)

export default component.exports